<template>
  <vertical-space :top="marginTop" :bottom="marginBottom" :backgroundColor="bgColor">
    <div
      class="case-view__margin"
      :class="{'inverted': inverted}"
    >
      <div class="case-view-item__content-container">
        <div class="half-screen">
          <div
            v-if="verticalImage"
            class="image-wrapper"
            :class="{'crop': !noCrop}"
            :style="{'padding-bottom': this.firstImageSizeRatio ? this.firstImageSizeRatio : ''}"
          >
            <img :data-src="image" alt="first header image" class="lazy" />
          </div>

          <div class="text-container">
            <h1
              :style="{'color': headingColor}"
              v-if="title"
              :class="{'small-header': smallHeader}"
            >{{ title }}</h1>
            <p :style="{'color': copyColor}">{{ copy }}</p>
          </div>
        </div>

        <div class="half-screen almost">
          <div
            class="image-wrapper"
            :class="{'crop': !noCrop}"
            :style="{'padding-bottom': this.secondImageSizeRatio ? this.secondImageSizeRatio : this.firstImageSizeRatio}"
          >
            <img :data-src="verticalImage || image" alt="first header image" class="lazy" />
          </div>
        </div>
      </div>
    </div>
  </vertical-space>
</template>

<script>
import LazyLoad from "vanilla-lazyload";
import verticalSpace from "@/components/vertical-space.vue"

export default {
  name: "CaseViewDoubleWithMargin",
  components: { verticalSpace },
  props: {
    inverted: Boolean,
    headingColor: String,
    copyColor: String,
    bgColor: String,
    title: String || false,
    copy: String || false,
    image: String,
    verticalImage: String || false,
    noCrop: Boolean,
    smallHeader: Boolean,

    marginTop: { type: Number, default: 0 },
    marginBottom: { type: Number, default: 0 },
  },
  data() {
    return {
      firstImageSizeRatio: "",
      secondImageSizeRatio: ""
    };
  },
  methods: {
    reveal(entries) {
      const children = entries[0].target.children[0].children; // todo: make to ref

      if (entries[0].intersectionRatio > 0.1) {
        for (let child of children) {
          child.classList.remove("unseen");
        }
      }
    },
    getImageMeta(url) {
      return new Promise((resolve, reject) => {
        let img = new Image();
        img.src = url;
        img.onload = () => resolve(img);
        img.onerror = reject;
      });
    },
    getImageSizeRatio(dataRef, image) {
      return this.getImageMeta(image).then(meta => {
        const ratio = (meta.height / meta.width) * 100 + "%";
        this[dataRef] = ratio;
      });
    }
  },
  mounted() {
    new LazyLoad({
      elements_selector: ".lazy"
    });
    this.getImageSizeRatio(
      "firstImageSizeRatio",
      this.verticalImage ? this.image : this.verticalImage
    );
    this.getImageSizeRatio(
      "secondImageSizeRatio",
      this.verticalImage || this.image
    );
  }
};
</script>

<style lang="scss">
@import "../scss/globals.scss";

.case-view__margin {
  display: flex;
  flex-direction: column;
  justify-content: center;

  position: relative;
  min-height: 50vh;
  padding: $margin1-1 $margin1-8;
  box-sizing: border-box;
  @media screen and (min-width: 769px) {
    padding: $margin2-1 $margin1-1;
    min-height: auto;
  }
  @media screen and (min-width: 377px) {
    padding: $margin1-2;
  }

  .case-view-item__content-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 100%;

    .half-screen {
      width: 100%;
      margin-bottom: $margin1-2;
      @media screen and (min-width: 550px) {
        width: 50%;
        margin-bottom: 0;
      }

      .text-container {
        margin: 0 0 $margin1-1;
        @media screen and (min-width: 1025px) {
          margin: $margin1-4 0 0;
        }
        @media screen and (min-width: 377px) {
          margin: $margin1-8 0 0;
        }

        h1 {
          font-size: $font-size-m;
          font-family: $font-expanded;
          line-height: $medium-line-height;
          @media screen and (min-width: 1025px) {
            font-size: $font-size-ml;
          }

          &.small-header {
            font-size: $font-size-sm;

            @media screen and (min-width: 1025px) {
              font-size: $font-size-m;
            }
          }
        }

        p {
          width: 100%;
          line-height: 2em;
          white-space: pre-wrap;
          @media screen and (min-width: 850px) {
            width: 75%;
          }
        }
      }

      &.almost {
        width: 80%;
        padding-left: 20%;
        box-sizing: border-box;
        @media screen and (min-width: 550px) {
          width: 50%;
          padding-left: 5%;
        }
      }

      .image-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;

        img {
          width: 100%;
          height: auto;
          position: absolute;
          top: 0;
          left: 0;
        }

        &.crop {
          max-height: 90vh;
          overflow: hidden;
        }
      }
    }
  }

  &.inverted {
    .case-view-item__content-container {
      flex-direction: row-reverse;
    }

    .half-screen.almost {
      padding-left: 0;
      padding-right: 5%;
    }
  }
}
</style>
